import React, { useState } from "react";
import { Box, Chip, Grid, Link, Typography } from "@mui/material";
import currency from "currency.js";
import LineItemDetails from "./LineItemDetails";
import ImageCarousel from "../ImageCarousel";

export default function LineItemV2(props) {
  const { item } = props;

  const [showMore, setShowMore] = useState(Boolean(props.showMore));

  return (
    <Grid container spacing={2}>
      <Grid item xs={2}>
        <ImageCarousel images={item.images} />
      </Grid>
      <Grid item xs={10}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Typography variant="h6">{item.title}</Typography>
            {props.view === "min" ? (
              <Box>
                <Link sx={{ cursor: "pointer", fontSize: ".9rem" }} onClick={() => setShowMore(!showMore)}>
                  {showMore ? "hide" : "show"} details
                </Link>
                {showMore && (
                  <Box sx={{ borderLeft: "2px solid #ECECEC", paddingLeft: "1rem" }}>
                    <LineItemDetails item={item} />
                  </Box>
                )}
              </Box>
            ) : (
              <LineItemDetails item={item} />
            )}
          </Grid>
          <Grid item xs={2} align="right">
            <Chip size="small" label={item.quantity} />
          </Grid>
          <Grid item xs={2} align="right">
            <Typography variant="overline">{currency(item.total).format()}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
